import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './core/components/not-found/not-found.component';
import { AuthGuardService } from './core/services/auth-guard/auth-guard.service';
import { AppPreloadingStrategy } from './core/app.preload';

const routes: Routes = [
  { path: '404', component: NotFoundComponent, data: {state: '404'}},
  { path: 'aeroview', canActivate: [AuthGuardService],
    data: {userRoles: ['client', 'staff'], state: 'aeroview'},
    children: [
      {
        path: '',
        data: {preload: true, delay: false},
        loadChildren: () => import('./pages/aeroview/aeroview.module').then(m => m.AeroviewModule),
      },
    ]
  },
  { path: '',
    redirectTo: 'log-in',
    pathMatch: 'full',
  },
  { path: 'log-in',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/log-in/log-in.module').then(m => m.LogInModule)
      }
    ]
  },
  { path: 'login',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/log-in/log-in.module').then(m => m.LogInModule)
      }
    ]
  },
  { path: 'forgot-password',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
      }
    ]
  },
  { path: 'confirm-account',
    children: [
      {
        path: '',
        data: {state: 'activate-account'},
        loadChildren: () =>
          import('./pages/create-update-account/create-update-account.module').then(m => m.CreateUpdateAccountModule)
      }
    ]
  },
  { path: 'activate-account',
    children: [
      {
        path: '',
        data: {state: 'activate-account'},
        loadChildren: () =>
          import('./pages/create-update-account/create-update-account.module').then(m => m.CreateUpdateAccountModule)
      }
    ]
  },
  { path: 'reset-password',
    children: [
      {
        path: '',
        data: {state: 'reset-password'},
        loadChildren: () =>
          import('./pages/create-update-account/create-update-account.module').then(m => m.CreateUpdateAccountModule)
      }
    ]
  },
  { path: 'create-account',
    children: [
      {
        path: '',
        data: {state: 'create-account'},
        loadChildren: () =>
          import('./pages/create-update-account/create-update-account.module').then(m => m.CreateUpdateAccountModule)
      }
    ]
  },
  { path: 'sign-up',
    children: [
      {
        path: '',
        data: {state: 'create-account'},
        loadChildren: () =>
          import('./pages/create-update-account/create-update-account.module').then(m => m.CreateUpdateAccountModule)
      }
    ]
  },
  { path: '**', redirectTo: '/404'},
];

export const AppRoutingModule = RouterModule.forRoot(routes,
  {preloadingStrategy: AppPreloadingStrategy});
